












































import { IInternetSccess } from "@/@types/admin/guest/user";
import { auth } from "@/config/host.config";
import { getDate } from "@/services/dateTime/getFullDate";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class GuestInternetAccess extends Vue {
  @Prop({ type: Object, default: null }) agent!: IInternetSccess;
  @Prop({ type: Boolean, default: false }) spinner!: boolean;
  @Prop({ type: String, default: "" }) login!: string;

  hasInternet = false; //наличие интернета
  isBlocked = false; // наличии в блэклисте
  isActive = false; //Активен ли пользователь

  get date(): string {
    if (!this.agent) return "";
    return getDate(this.agent.date);
  }

  async getInternetStatus(): Promise<void> {
    this.$emit("spinner", true);
    const uri = auth.internet_getstatus;
    try {
      const f = this.agent.ip.split(".");
      if (!f.length) return;
      const params = {
        ip: this.agent.ip,
        user: this.login + "_" + f[f.length - 1],
      };
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) {
        const result = res.data.result;
        if (!result) return;
        this.hasInternet = result.hasInternet ? result.hasInternet : false;
        this.isBlocked = result.isBlocked ? result.isBlocked : false;
        this.isActive = result.isActive ? result.isActive : false;
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$emit("spinner", false);
    }
  }

  sentCode(): void {
    this.$emit("sentCode", this.agent);
    setTimeout(() => this.getInternetStatus(), this.$second(1));
  }

  mounted(): void {
    this.$nextTick(() => this.getInternetStatus());
  }
}
